"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _uuid = require("uuid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconTick = function IconTick(_ref) {
  var className = _ref.className;
  var labelId = (0, _uuid.v4)();
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: className,
    viewBox: "0 0 50 50",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": labelId
  }, /*#__PURE__*/_react["default"].createElement("title", {
    id: labelId
  }, "Tick"), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "14.6553946 35.392902 5.19935444 25.8272493 0 31.0869305 12.4784711 43.7100827 12.4927896 43.6954946 14.7708631 46 50 10.3619014 44.6998024 5"
  })));
};

var _default = IconTick;
exports["default"] = _default;